import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  base_url: string = DDP_ENV.baseUrl;
  constructor(private _router: Router, private _http: Http, private cookieService: CookieService) {

  }
  /****************************** Metric ******************************************/
	/* Get Metric */
  getMetricByPatientIdAndMetricId(patientId, metricId): Observable<any> {
    return this._http.get(this.base_url + '/dataservice/sdata/multiple/latest/conv?metricId=' + metricId + "&patientId=" + patientId, this.buildHeaders()).map((res: Response) => res.json());
  }

  getPatientById(id){
    return this._http.get(this.base_url + '/app/patient/id/' + id, this.buildHeaders());
  }

  getMetricByName(metricName: string): Observable<any> {
    return this._http.get(this.base_url + '/device/metric/' + metricName, this.buildHeaders()).map((res: Response) => res.json());
  }
 
  /****************************** Create headers ******************************************/
  /* Build request header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }

}
